import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '@/styles/pages/AuthPage.module.css';

const faqItems = [
  {
    question: 'What is Swarmind?',
    answer:
      'Swarmind is a decentralised platform which provides access to custom large language models hosted on private machines.',
  },
  {
    question: 'What services does Swarmind provide?',
    answer:
      'First and foremost, we provide access to various LLMs, including text models, image generation, text-to-speech and image recognition. Secondly, we provide authors of models with a way to monetize their work via our decentralised payment system. Same goes for hardware suppliers.',
  },
  {
    question: 'How does our payment system work?',
    answer:
      "We're a decentralised platform, so we incorporate web3 to manage payments: in exchange for USDT you get access to any custom model that suits your needs. Of course, we also provide you with free tokens so you can just play around before moving forward.",
  },
  {
    question: 'How to use the service?',
    answer: 'Just pick your desired model in the chat window and chat with it.',
  },
  {
    question: 'How to connect my GPU?',
    answer:
      "Currently we connect hardware to cluster manually. Just contact us via Telegram and we'll set you up!",
  },
  {
    question: 'How to apply my LLM?',
    answer: 'For a detailed walkthrough and help, contact us via Telegram!',
  },
];

const AuthPage: React.FC = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [isFaqCollapsed, setIsFaqCollapsed] = useState(false);

  return (
    <div className={styles.container}>
      {/* Main card */}
      <main className={styles.main}>
        <div className={styles.contentLayout}>
          <div className={styles.card}>
            {/* Early access pill */}
            <span className={styles.earlyAccessPill}>
              Early Access
            </span>

            {/* Logo text */}
            <h1 className={styles.logoText}>
              swarmind
            </h1>

            {/* Tagline */}
            <p className={styles.tagline}>
              Decentralized AI platform
            </p>

            {/* Buttons */}
            <div className={styles.buttonContainer}>
              <button
                className={styles.primaryButton}
                onClick={() => {
                  window.location.href = 'https://swarmind.ai/login';
                }}
              >
                Log in
              </button>
            </div>
          </div>

          {/* FAQ Sidebar */}
          <aside
            className={`${styles.faqSidebar} ${
              isFaqCollapsed ? styles.faqSidebarCollapsed : ''
            }`}
            aria-label="Swarmind frequently asked questions"
          >
            <button
              type="button"
              className={styles.faqToggleButton}
              onClick={() => setIsFaqCollapsed(prev => !prev)}
              aria-label={isFaqCollapsed ? 'Expand FAQ sidebar' : 'Collapse FAQ sidebar'}
            >
              <img
                src="/icons/double_arrows.svg"
                alt=""
                className={styles.faqToggleIcon}
              />
            </button>
            <h2 className={styles.faqTitle}>Frequently asked questions</h2>
            <div className={styles.faqList}>
              {faqItems.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={item.question}
                    className={`${styles.faqItem} ${isOpen ? styles.faqItemOpen : ''}`}
                  >
                    <button
                      type="button"
                      className={styles.faqQuestionButton}
                      onClick={() =>
                        setOpenIndex(prev => (prev === index ? null : index))
                      }
                      aria-expanded={isOpen}
                    >
                      <span className={styles.faqQuestion}>{item.question}</span>
                      <span className={styles.faqChevron}>
                        {isOpen ? '−' : '+'}
                      </span>
                    </button>
                    {isOpen && (
                      <div className={styles.faqAnswerWrapper}>
                        <p className={styles.faqAnswer}>{item.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </aside>
        </div>
      </main>

      {/* Footer */}
      <footer className={styles.footer}>
        <a href="#" className={styles.footerLink}>
          Data Policy
        </a>
        <div className={styles.footerDivider} />
        <a href="#" className={styles.footerLink}>
          User Agreement
        </a>
      </footer>
    </div>
  );
};

export default AuthPage; 